import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { map } from 'rxjs';
import { BreadcrumbService } from 'app/core/navigation/breadcrumb.service';

/**
 * Renders the breadcrumb trail for the active route.
 *
 * Mounted once in the layout toolbar so every page gets a trail — including the
 * flat Products area and the standalone form pages, none of which have a
 * container component to host one.
 */
@Component({
    selector: 'breadcrumb',
    templateUrl: './breadcrumb.component.html',
    standalone: true,
    imports: [AsyncPipe, MatIconModule, RouterLink],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbComponent {
    breadcrumbs$ = inject(BreadcrumbService).breadcrumbs$;

    /**
     * The nearest ancestor crumb that is a link — the natural "up one level"
     * target. Rendered as a single back link on mobile, where the full trail is
     * hidden.
     */
    backCrumb$ = this.breadcrumbs$.pipe(
        map((crumbs) => [...crumbs].reverse().find((crumb) => !!crumb.url) ?? null),
    );
}
